import CodeEditorIcons, { CodeEditorIconsProps } from './CodeEditorIcons';

export type { CodeEditorIconsProps };
export default CodeEditorIcons;
